export default "__VITE_ASSET__9rvQd2x___"